export const destinations = (req) => {
    console.log(req);
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(`${req.isSrp ? '/activity/' : ''}api/destination?destination_id=${req.payload.destination_id}`, requestOptions).then((response) => response.json())
}
